/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const loginRequestV4Schema = z.object({
  email: z.string().min(1).default(''),
  password: z.string().min(1).default(''),
})
